import ContentBelow from "../components/ContentBelow";
import Head from "../components/Head";
import background from "../images/BlogHeadingBackGround.jpg";
import PostList from "./PostList";
import classes from "../components/Blog.module.css";
import BlogTreeView from "../components/BlogTreeView";

function Blog() {
  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">Our Blogs</h2>
      </Head>
      <ContentBelow AddStyle={" bg-light"}>
        <div className="col-lg-11 mt-4 mx-auto">
          <h2
            className="text-center"
            style={{
              color: "#113358",
              fontFamily: "arial black",
              fontSize: "36px",
            }}
          >
            Hit the Brakes - It's Blog 'o Clock
          </h2>
          <p
            style={{ color: "#113358", fontFamily: "arial" }}
            className="text-center col-5 mx-auto"
          >
            Stay updated with the latest insights, news, and expert tips from
            our blog, designed to help you navigate the world of RAF claims and
            legal financing.
          </p>
        </div>
        <div className="container mx-auto mt-5 mb-2 justify-content-center d-flex">
          <div className="row">
            {/* Left side */}
            <div className="col-md-3">
              <BlogTreeView />
            </div>

            {/* Right side */}
            <div className="col-md-9">
              <PostList />
            </div>
          </div>
        </div>
      </ContentBelow>
    </>
  );
}
export default Blog;
